/* Dog District — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.dd-reveal:not(.dd-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('dd-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('dd-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-dd-contar]:not([data-dd-hecho])');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el); el.setAttribute('data-dd-hecho', '');
        var fin = parseFloat(el.getAttribute('data-dd-contar')) || 0;
        var suf = el.getAttribute('data-dd-sufijo') || '';
        var dec = (String(fin).split('.')[1] || '').length;
        if (reduce) { el.textContent = fin.toLocaleString('es-AR') + suf; return; }
        var t0 = null, dur = 1600;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          el.textContent = (fin * e).toLocaleString('es-AR', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initProducto() {
    document.querySelectorAll('[data-dd-pdp]').forEach(function (root) {
      if (root.dataset.ddListo) return; root.dataset.ddListo = '1';
      var principal = root.querySelector('[data-dd-principal]');
      var minis = root.querySelectorAll('[data-dd-mini]');
      function mostrar(src, srcset, alt, idMedia) {
        if (!principal) return;
        principal.style.opacity = 0;
        setTimeout(function () { principal.src = src; if (srcset) principal.srcset = srcset; principal.alt = alt || ''; principal.style.opacity = 1; }, 150);
        minis.forEach(function (m) { m.classList.toggle('is-activa', m.getAttribute('data-dd-media') == idMedia); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrar(m.dataset.src, m.dataset.srcset, m.dataset.alt, m.dataset.ddMedia); });
      });

      var json = root.querySelector('[data-dd-variantes]');
      var variantes = json ? JSON.parse(json.textContent) : [];
      var form = root.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var precio = root.querySelectorAll('[data-dd-precio]');
      var tachado = root.querySelectorAll('[data-dd-tachado]');
      var ahorro = root.querySelector('[data-dd-ahorro]');
      var botones = root.querySelectorAll('[data-dd-boton]');
      var txtAgotado = root.dataset.agotado, txtComprar = root.dataset.comprar;
      var formato = root.dataset.moneda || '${{amount}}';

      function dinero(c) {
        var n = (c / 100);
        var con = function (dec, mil, sepDec) { var p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil); return p.join(sepDec); };
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
          if (k === 'amount_no_decimals') return con(0, ',', '.');
          if (k === 'amount_with_comma_separator') return con(2, '.', ',');
          if (k === 'amount_no_decimals_with_comma_separator') return con(0, '.', ',');
          if (k === 'amount_with_period_and_space_separator') return con(2, ' ', '.');
          return con(2, ',', '.');
        });
      }

      function actualizar() {
        var sel = [];
        root.querySelectorAll('[data-dd-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { botones.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = txtAgotado; }); return; }
        if (inputId) inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = dinero(v.price); });
        tachado.forEach(function (t) { t.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; });
        if (ahorro) { if (v.compare_at_price > v.price) { ahorro.hidden = false; ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; } else ahorro.hidden = true; }
        botones.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? txtComprar : txtAgotado; });
        if (v.featured_media) {
          var m = root.querySelector('[data-dd-mini][data-dd-media="' + v.featured_media.id + '"]');
          if (m) m.click();
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('[data-dd-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = root.querySelector('[data-dd-cantidad]');
      if (cant) {
        var inp = cant.querySelector('input');
        cant.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () { var n = parseInt(inp.value, 10) || 1; inp.value = Math.max(1, n + parseInt(b.dataset.paso, 10)); });
        });
      }

      // Barra fija en móvil
      var barra = root.querySelector('.dd-barra-movil');
      var principalBtn = root.querySelector('.dd-compra__boton');
      if (barra && principalBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { barra.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(principalBtn);
        barra.querySelector('[data-dd-boton]').addEventListener('click', function () { principalBtn.click(); });
      }
    });
  }

  function initIdioma() {
    document.querySelectorAll('[data-dd-idioma]').forEach(function (f) {
      if (f.dataset.ddListo) return; f.dataset.ddListo = '1';
      f.querySelectorAll('button[data-locale]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          f.querySelector('input[name="locale_code"]').value = b.dataset.locale;
          f.submit();
        });
      });
    });
  }

  function initTodo() { initReveal(); initCifras(); initProducto(); initIdioma(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
